<div class="popup">
  <form [formGroup]="forgotForm" novalidate (ngSubmit)="onSubmit()">
    <div class="form-control-group">
      <label i18n="@@ForgotPasswordHint">Укажите e-mail, который вы использователи при регистрации</label>

      <div class="form-control-group">
        <input formControlName="email" nbInput id="resetInputEmail1" type="email"
               i18n-placeholder="@@EnterEmail" placeholder="Введите e-mail" autocomplete="off">
      </div>
      @if (forgotForm.controls.email.errors?.required && forgotForm.controls.email.touched) {
        <div class="invalid-feedback" i18n>укажите e-mail</div>
      }
      @if (forgotForm.controls.email.errors?.email && forgotForm.controls.email.touched) {
        <div class="invalid-feedback" i18n>неверный e-mail</div>
      }
    </div>

    <div class="form-control-group form-content__btn">
      <button [disabled]="forgotForm.invalid" nbButton type="submit" i18n>Отправить</button>&nbsp;<a [href]="" nbButton (click)="close()" i18n="@@Cancel">Отмена</a>
    </div>
  </form>
</div>
